<template>
  <div v-if="obra">
    <v-row :class="{ 'flex-column-reverse': vuetify?.breakpoint.smAndDown }">
      <v-col>
        <TabelaLocalizacao
          v-if="obra.localizacaoList"
          class="mt-1 mb-2"
          :items="obra.localizacaoList"
        />

        <v-row dense>
          <Info cols="6" label="Classificação" :value="obra.deClassificacao" />

          <Info
            cols="6"
            label="Notação do autor"
            :value="obra.deNotacaoAutor"
          />
        </v-row>

        <v-row dense>
          <Info cols="6" label="Autor(es)" :value="obra.autorList" />
          <Info
            cols="6"
            label="Autor(es) secundário(s)"
            :value="obra.autorSecundarioList"
          />
        </v-row>

        <v-row dense>
          <Info cols="12" label="Título" :value="obra.titulo" />
          <Info
            cols="6"
            label="Publicações"
            :value="formatarPublicacoes(obra.obraEditoraList)"
          />
          <Info cols="12" label="Idioma(s)" :value="obra.idiomaList" />
          <Info cols="12" label="Nota(s)" :value="obra.notaList" />
          <Info cols="12" label="Assunto(s)" :value="obra.assuntos" />
          <Info
            cols="6"
            label="Instituição de defesa"
            :value="obra.instituicaoDefesa"
          />

          <Info cols="6" label="Grau" :value="obra.grau" />

          <Info cols="6" label="Data de defesa" :value="obra.dataDefesa" />

          <Info
            cols="6"
            label="Banca examinadora"
            :value="obra.bancasExaminadoras"
          />
        </v-row>
      </v-col>
    </v-row>
  </div>
</template>

<script setup lang="ts">
import Info from '@/components/DynamicInfo.vue';
import TabelaLocalizacao from './TabelaLocalizacao.vue';
import { ConsultaObrasStore } from '../../store/ConsultaObrasStore';
import { storeToRefs } from 'pinia';
import { formatarPublicacoes } from '@/utils/util';
import { useVuetify } from '@/composables/useVuetify';

const vuetify = useVuetify();
const store = ConsultaObrasStore();
const { obraTempImpressao: obra } = storeToRefs(store);
</script>
